import React from "react";
import PropTypes from "prop-types";

import "./style.scss";

const HereToHelpCard = ({ headerHTML, contentHTML, btnLabel, btnHref }) => (
  <div className="help-card container">
    <div className="help-card__content grid-container">
      <h2
        className={`header grid-col-12 text-center`}
        dangerouslySetInnerHTML={{ __html: headerHTML }}
      />

      <div
        className="excerpt grid-col-12 text-center"
        dangerouslySetInnerHTML={{ __html: contentHTML }}
      />
      <a
        className="faq-bottom-link grid-col-12 text-center"
        href={btnHref}
        rel="noreferrer noopener"
      >
        {btnLabel} <i className="fa fa-external-link" aria-hidden="true"></i>
      </a>
    </div>
  </div>
);

HereToHelpCard.propTypes = {
  headerHTML: PropTypes.any,
  contentHTML: PropTypes.any,
  btnLabel: PropTypes.string,
  btnHref: PropTypes.string,
};

export default HereToHelpCard;
